import comp from "./WorkrampAcademy";
export default comp;
